module.exports = __webpack_public_path__ + "img/problem-mail-img.0e307017.png";